import React from 'react';
import {
  Container,
  Typography,
  Box,
  Breadcrumbs,
  Link,
} from '@mui/material';
import {
  NavigateNext as NavigateNextIcon,
  Home as HomeIcon,
  Assessment as AssessmentIcon,
  TableChart as TableChartIcon,
  Assignment as AssignmentIcon,
} from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { DocumentIdentificationWizard } from '../../../components/appraisals/construction/DocumentIdentificationWizard';

export const DocumentIdentificationWizardPage: React.FC = () => {
  const navigate = useNavigate();
  const { constructionId } = useParams<{ constructionId: string }>();

  const handleComplete = (documentId: number) => {
    navigate(`/admin/deliverables/doc-id-system/documents/${documentId}`);
  };

  const handleCancel = () => {
    navigate(-1); // Go back to previous page
  };

  if (!constructionId) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" color="error">
          Construction ID is required
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ mb: 3 }}>
        <Link 
          color="inherit" 
          href="/dashboard"
          sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
        >
          <HomeIcon fontSize="inherit" />
          Dashboard
        </Link>
        <Link 
          color="inherit" 
          href="/appraisals"
          sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
        >
          <AssessmentIcon fontSize="inherit" />
          Appraisals
        </Link>
        <Link 
          color="inherit" 
          onClick={() => navigate(-1)}
          sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }}
        >
          <TableChartIcon fontSize="inherit" />
          Excel Analysis
        </Link>
        <Typography color="text.primary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <AssignmentIcon fontSize="inherit" />
          Identify Document
        </Typography>
      </Breadcrumbs>

      {/* Header */}
      <Box mb={4}>
        <Typography variant="h4" component="h1" gutterBottom>
          Document Identification
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Follow the guided process to identify and configure your Excel document for data extraction.
        </Typography>
      </Box>

      {/* Wizard Component */}
      <DocumentIdentificationWizard
        constructionId={constructionId}
        onComplete={handleComplete}
        onCancel={handleCancel}
      />
    </Container>
  );
};